import { cn } from '@lib/cn'
import React, { FC } from 'react'

type RolexContainerProps = {
  className?: string
  as?: 'div' | 'section'
}

export const RolexContainer: FC<RolexContainerProps> = ({
  className,
  children,
  as = 'section',
}) => {
  const Component = as
  return (
    <Component className={cn('container mx-auto w-[100vw] max-w-[86%] md:max-w-[84%]', className)}>
      {children}
    </Component>
  )
}
